import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100vh;
`;

export const Title = styled.h1`
    font-size: 128px;
    font-weight: 700;
    color: ${({ theme }) => theme.color.primary};
`;

export const Subtitle = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: ${({ theme }) => theme.color.primary};
`;

export const Description = styled.p`
    font-size: 16px;
    color: ${({ theme }) => theme.color.text_light};
`;
